import styled from "styled-components";

export const DivContainerTable = styled.div`
  margin-top: 2rem;
  max-height: fit-content;
  width: 89.5vw;
  @media (max-width: 2500px) {
    width: 89vw;
  }
  @media (max-width: 2250px) {
    width: 87vw;
  }
  @media (max-width: 2100) {
    width: 86vw;
  }
  @media (max-width: 1920px) {
    width: 85vw;
  }
  @media (max-width: 1500px) {
    width: 80vw;
  }
  @media (max-width: 1100px) {
    width: 95.5vw;
  }
  @media (max-width: 760px) {
    width: 90vw;
  }
`;

export const DivContentTable = styled.div`
  background: #ffffff;
  height: fit-content;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c6c8ce;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #ffffff;
  }
  &::-webkit-scrollbar-corner {
    background-color: #ffffff;
  }
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  font-size: 14px;
  min-width: max-content;
  text-align: left;
  width: 100%;

  thead {
    background: #002e6c;
    color: #ffffff;
    padding: 10px;
    position: sticky;
    text-aling: center;
    top: 0;
    th {
      border-right: 1px solid #f2f3f8;
      padding: 1rem;
      position: relative;
      text-align: center;
      font-family: Montserrat;
      font-size: 1.4rem;
    }
    th:last-child {
      border-right: none;
    }
  }
  tbody {
    td {
      border-right: 1px solid #e1e1e1;
      border-bottom: 1px solid #e1e1e1;
      border-top: 1px solid #e1e1e1;
      text-align: center;
      font-family: Montserrat;
      font-size: 1.4rem;
    }
  }

  tbody tr {
    background: #ffffff;
  }
  .background-in-hover:hover td {
    background: rgba(118, 188, 33, 0.5);
    color: #ffffff;
  }
  .background-in-hover-active td {
    background: rgba(0, 104, 243, 0.05);
    color: #08082b;
  }
  .resizeActive {
    padding: 1rem;
    resize: horizontal;
    overflow: auto;
  }
  td,
  th {
    padding: 1rem;
    overflow: auto;
  }
  .resize-handle {
    display: block;
    position: absolute;
    cursor: col-resize;
    width: 7px;
    right: 0;
    top: 0;
    z-index: 1;
    border-right: 2px solid transparent;
  }

  .resize-handle:hover {
    border-color: #ccc;
  }
`;

export const DivPenddingSearch = styled.div`
  align-items: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: 40vh;
  justify-content: center;
  img {
    height: auto;
    width: 10rem;
  }
  .pendding-text {
    color: rgba(0, 0, 0, 0.3);
    font-size: 1.4rem;
    padding-top: 2rem;
  }
  width: 89.5vw;
  @media (max-width: 2500px) {
    width: 89vw;
  }
  @media (max-width: 2200px) {
    width: 87vw;
  }
  @media (max-width: 1920px) {
    width: 85vw;
  }
  @media (max-width: 1500px) {
    width: 80vw;
  }
  @media (max-width: 1100px) {
    width: 95.5vw;
  }
  @media (max-width: 760px) {
    width: 90vw;
  }
`;

interface IButtonContent {
  backgroundColor?: string;
  border?: string;
  borderRadius?: string;
  borderWidth?: string;
  color?: string;
  fontSize?: string;
  height?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginTop?: string;
  placeholder?: string;
  width?: string;
}
export const ButtonContent = styled.button<IButtonContent>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    background-color: ${
      props.backgroundColor ? props.backgroundColor : "#002E6C"
    };
    border: ${props.border ? props.border : "none"};
    border-width: ${props.borderWidth ? props.borderWidth : "none"};
    border-radius: ${props.borderRadius ? props.borderRadius : "8px"};
    color: ${props.color ? props.color : "#FFFFFF"};
    height: ${props.height ? props.height : "5rem"};
    margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
    margin-top: ${props.marginTop ? props.marginTop : "0rem"};
    width: ${props.width ? props.width : "100%"};
    box-shadow: 0px 10px 20px rgba(48, 52, 92, 0.19);
`}
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  font-weight: 700;
  justify-content: center;
  position: relative;
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.backgroundColor + props.theme.transparencies.p20};
    cursor: not-allowed;
  }
  img {
    margin-left: 1rem;
  }
  .notification-circle {
    background: #ff6f61;
    border: 1px solid #ff6f61;
    border-radius: 50%;
    padding: 0.5rem;
    position: absolute;
    right: 0;
    margin-left: -6px;
    margin-top: -6px;
    left: 100%;
    top: 0%;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    margin-top: 1rem;
  }
`;
export const MainHeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 760px) {
    flex-direction: column;
  }
`;

interface ISidebarContainerCommon {
  height?: string | number;
  width?: string | number;
  backgroundColor?: string | number;
  color?: string;
}
export const SidebarContainerCommon = styled.div<ISidebarContainerCommon>`
  ${(props) => `
    background-color: ${
      props.backgroundColor ? props.backgroundColor : "white"
    };
    color: ${props.color ? props.color : "#000000"};
    height: ${props.height ? props.height : "100vh"};
    width: ${props.width ? props.width : "49.5rem"};
  `}
  border-radius: 1rem 0 0 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 3rem 3rem 1.2rem;
  .sidebar-title {
    display: flex;
    flex-direction: column;
  }
`;

export const SidebarTitle = styled.div`
  color: ${(props) => props.theme.colors.primaryBlue};
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 1.8rem;
  img {
    margin-right: 1rem;
  }
`;

export const CardContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 1rem;
  margin-top: 2rem;
  height: 85vh;

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #76bc21;
    border-radius: 1rem;
  }
  &::-webkit-scrollbar-track {
    background: #f0f0f0;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  @keyframes changeShadow {
    from {
      box-shadow: 0px 2px 15px rgba(167, 167, 167, 0.3);
    }
    to {
      box-shadow: 0px 2px 15px rgba(118, 188, 33, 0.5);
    }
  }

  .box {
    animation: changeShadow 1.7s ease-in-out infinite;
  }
  .success-box {
    box-shadow: 0px 2px 15px rgba(167, 167, 167, 0.3);
  }
`;

export const CardContent = styled.div`
  align-items: center;
  background: #FFFFF;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: row;
  font-family: Montserrat;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 1.5rem;
  width: 100%;

  .title-card {
    font-weight: 800;
    font-size: 1.2rem;
    margin: 0.5rem 0rem;
  }
`;

export const ProgressReportLabel = styled.div`
  color: #2e353d;
  display: flex;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 800;
  justify-content: center;
`;

export const HeaderSubTableAppoinment = styled.th`
  background-color: #76bc21;
  border: 1px solid #e9ecef;
  color: #ffffff;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
`;
